/**
 * Visit Notes Controller (Driver Adapter)
 *
 * Interface layer between UI and business logic
 */

import type {
  IVisitNotesController,
  IVisitNotesService,
  ICreateVisitNoteRequest,
  IUpdateVisitNoteRequest,
  ICreateVisitNoteResponse,
  IUpdateVisitNoteResponse,
} from "../../core/ports/driver/VisitNotesService";

export const VisitNotesControllerFactory = ({
  visitNotesService,
}: {
  visitNotesService: IVisitNotesService;
}): IVisitNotesController => {
  /**
   * Create a new visit note (draft or completed)
   */
  const createVisitNote = async (
    request: ICreateVisitNoteRequest
  ): Promise<ICreateVisitNoteResponse> => {
    return await visitNotesService.createVisitNote(request);
  };

  /**
   * Update/auto-save a visit note
   */
  const updateVisitNote = async (
    clinicId: number,
    patientId: number,
    noteId: number,
    request: IUpdateVisitNoteRequest
  ): Promise<IUpdateVisitNoteResponse> => {
    return await visitNotesService.updateVisitNote(
      clinicId,
      patientId,
      noteId,
      request
    );
  };

  return {
    createVisitNote,
    updateVisitNote,
  };
};

export type IVisitNotesControllerType = ReturnType<
  typeof VisitNotesControllerFactory
>;
